import React from 'react';

const Loader = () => (
  <div className="loader-d">
    <div className="loader">
      <div className="inner one"/>
      <div className="inner two"/>
      <div className="inner three"/>
    </div>
  </div>
);

export default Loader;
